import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/pages/Login'
import UserList from '@/pages/UserManage/UserList'
import EmpList from '@/pages/UserManage/EmpList'
import VendorList from '@/pages/VendorManage/VendorList/VendorList'
import VendorCheck from '@/pages/VendorManage/VendorCheck/VendorCheck'
import BizOrgList from "@/pages/BizOrgManage/BizOrgList.vue";
import Index from '@/pages/Index'
import LoginLayout from "../layouts/LoginLayout";
import MainLayout from "../layouts/MainLayout";
import PointBuy from "../pages/PointManage/PointBuy/PointBuy";
import CouponList from "../pages/CouponManage/CouponList";
import CouponUse from "../pages/CouponManage/CouponUse/CouponUse"
import BonusPointPay from "../pages/PointManage/BonusPointPay/BonusPointPay";
import PointWithdraw from "../pages/PointManage/PointWithdraw/PointWithdraw";
import PointRecord from "../pages/PointManage/PointRecord/PointRecord";
import CabinetList from "@/pages/BizOrgManage/CabinetList.vue";
import RechargeList from "@/pages/UserManage/RechargeList.vue";
import OrderList from "@/pages/UserManage/OrderList.vue";
import SuggestList from "@/pages/Customer/SuggestList.vue";

Vue.use(Router)

export const constantRoutes = [
    {
        path: '/login',
        component: LoginLayout,
        children: [
            {
                path: "/",
                name: "Login",
                component: Login
            }
        ],
    },
    {
        path: '/',
        redirect: '/index',
        component: MainLayout,
        children: [
            {
                path: "/index",
                meta: {title: ["首页"], menuKey: ["index", "index"]},
                component: Index
            },
            {
                path: "/userManage/userList",
                meta: {title: ["用户管理", "学生管理"], menuKey: ["userManage", "userList"]},
                component: UserList
            },
            {
                path: "/userManage/empList",
                meta: {title: ["用户管理", "员工管理"], menuKey: ["userManage", "empList"]},
                component: EmpList
            },
            {
                path: "/userManage/rechargeList",
                meta: {title: ["用户管理", "充值记录"], menuKey: ["userManage", "rechargeList"]},
                component: RechargeList
            },
            {
                path: '/userManage/orderList',
                meta: {title: ["用户管理", "洗衣订单"], menuKey: ["userManage", "orderList"]},
                component: OrderList
            },
            {
                path: '/vendorManage/vendorList',
                meta: {title: ["商户管理", "商户列表"], menuKey: ["vendorManage", "vendorList"]},
                component: VendorList
            },
            {
                path: '/bizOrgManage/bizOrgList',
                meta: {title: ["学校管理", "学校列表"], menuKey: ["bizOrgManage", "bizOrgList"]},
                component: BizOrgList
            },
            {
                path: '/bizOrgManage/cabinetList',
                meta: {title: ["学校管理", "智能柜管理"], menuKey: ["bizOrgManage", "cabinetList"]},
                component: CabinetList
            },
            {
                path: '/customer/suggestList',
                meta: {title: ["客服管理", "意见反馈"], menuKey: ["customer", "suggestList"]},
                component: SuggestList
            },
            {
                path: '/pointManage/pointBuy',
                meta: {title: ["积分管理", "积分购买"], menuKey: ["pointManage", "pointBuy"]},
                component: PointBuy
            },
            {
                path: '/pointManage/bonusPointPay',
                meta: {title: ["积分管理", "积分赠送"], menuKey: ["pointManage", "bonusPointPay"]},
                component: BonusPointPay
            },
            /*{
                path: '/pointManage/bonusPointConfig',
                meta: {title: ["积分管理", "积分赠送配置"], menuKey: ["pointManage", "bonusPointConfig"]},
                component: BonusPointConfig
            },*/
            {
                path: '/pointManage/pointWithdraw',
                meta: {title: ["积分管理", "积分提现"], menuKey: ["pointManage", "pointWithdraw"]},
                component: PointWithdraw
            },
            {
                path: '/pointManage/pointRecord',
                meta: {title: ["积分管理", "积分变动记录"], menuKey: ["pointManage", "pointRecord"]},
                component: PointRecord
            },
            {
                path: '/couponManage/couponList',
                meta: {title: ["消费券管理", "消费券列表"], menuKey: ["pointManage", "couponList"]},
                component: CouponList
            },
            {
                path: '/couponManage/couponUse',
                meta: {title: ["消费券管理", "消费券使用"], menuKey: ["pointManage", "couponUse"]},
                component: CouponUse
            },
        ]
    },
]

const createRouter = () => new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
})
const router = createRouter()

export default router
